import React from 'react'
import SecureBookingModel from './SecureBookingModel'
import { Button } from '@mui/material'
import playstore from "../asserts/google.png";
import appstore from "../asserts/apple.png";
import { IoCall } from "@react-icons/all-files/io5/IoCall";
import { BiMessageRoundedDetail } from "react-icons/bi";
import { MdOutlineStar } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";

const SecureBookingDetail = ({isModalOpen}) => {
  return (
    <>
    <div className='container'>
      <div className='mt-5 mb-5 position-relative'>
        {/* <div className='secure-booking-app-link flex-column justify-content-center float-end position-absolute d-none d-lg-flex'>
          <a href="https://apps.apple.com/in/developer/insta-guard/id1735265056" target="blank" >
            <img style={{width: "200px"}} src={appstore} alt="appstore"/>
          </a>
          <a href="https://play.google.com/store/apps/developer?id=FCEM+LIMITED" target="blank" className='mt-2'>
            <img style={{width: "200px"}} src={playstore} alt="playstore"/>
          </a>
        </div> */}
        <div className='d-flex flex-column justify-content-center align-items-center secure-booking-desc'>
          <h1 className='secure-booking-title'>Hire an Emergency Security Guard in </h1>
          <h1 className='secure-booking-title'>Minutes - Anywhere in the UK </h1>
          <p className='secure-booking-txt'>Bespoke Security for Distinguished Homes&Residents</p>
        </div>
        <div className='d-flex align-items-center secure-booking-btn ps-4'>
          <div className='me-4 mb-3 secure-btn'>
            <SecureBookingModel questionModal={isModalOpen}/>
          </div>
          <div className='me-4 mb-3 secure-btn'>
            <a href='tel:0333 577 2477' className='phone-link-text app-color' target='_blank'>
                <Button
                        variant="contained"
                        sx={{
                          minHeight: "65px",
                          borderRadius: "10px",
                          boxShadow: 2,
                          backgroundColor: "#832b67",
                          color: "#fff",
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor: "#832b67",
                          },
                          fontSize: '1.5rem',
                          fontWeight: 'bold'
                        }}
                        className='secure-btn'
                      >
                        <IoCall size={24} className='me-3'/> Call Now: 0333 577 2477
                </Button>
             </a>
          </div>
          <div className='mb-3 secure-btn'>
            <a target="blank" href="https://api.whatsapp.com/send?phone=447920400283">
              <Button
                      variant="contained"
                      sx={{
                        minHeight: "65px",
                        borderRadius: "10px",
                        boxShadow: 2,
                        backgroundColor: "#2A2F83",
                        color: "#fff",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#2A2F83",
                        },
                        fontSize: '1.5rem',
                        fontWeight: 'bold'
                      }}
                      className='secure-btn'
                    >
                    <IoLogoWhatsapp size={24} className='me-3'/> Message Us
              </Button>
            </a>
          </div>
        </div>
        {/* <div className='d-flex flex-row justify-content-between align-items-center d-lg-none app-design'>
          <a href="https://apps.apple.com/in/developer/insta-guard/id1735265056" target="blank" >
            <img style={{width: "150px"}} src={appstore} alt="appstore" className='app-logo'/>
          </a>
          <a href="https://play.google.com/store/apps/developer?id=FCEM+LIMITED" target="blank" >
            <img style={{width: "150px"}} src={playstore} alt="playstore" className='app-logo'/>
          </a>
        </div> */}
      </div>
    </div>
    <div className='secure-booking-content'>
      <div className='container'>
        <div className='row mt-2 secure-booking-btn'>
          <div className='col-md-4'>
            {Array.from({ length: 5 }).map((_, index) => (
              <MdOutlineStar key={index} color="#D2A126" fontSize={30} />
            ))}
            <p className='mt-2 fs-4'>"Guard arrived within <br /> 8 minutes - <br /> absolute <br /> lifesaver!"</p>
          </div>
          <div className='col-md-4'>
            {Array.from({ length: 5 }).map((_, index) => (
              <MdOutlineStar key={index} color="#D2A126" fontSize={30} />
            ))}
            <p className='mt-2 fs-4'>"The best thing we've<br /> done for our pub.<br /> Highly professional.</p>
          </div>
          <div className='col-md-4'>
            {Array.from({ length: 5 }).map((_, index) => (
              <MdOutlineStar key={index} color="#D2A126" fontSize={30} />
            ))}
            <p className='mt-2 fs-4'>"Arrived even faster <br /> than a 999 response!"</p>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default SecureBookingDetail